module.exports = __webpack_public_path__ + "img/person-walking-with-cane.a539d1a0.svg";